export default {
	// backend: window.webpackHotUpdate ? "http://localhost:3000" : "http://moco.richardyrh.com:3000",
	// backend: window.webpackHotUpdate ? "http://localhost:3000" : "https://moco-backend.richardyrh.com",
	// adminBackend: (window.webpackHotUpdate ? "http://localhost:3000" : "https://moco-backend.richardyrh.com") +
	// "/admin",
	// sentinelBackend: "https://moco-backend.richardyrh.com/sentinel"
	backend: window.webpackHotUpdate ? "http://localhost:3000" : "https://backend.moco-1.com",
	adminBackend: (window.webpackHotUpdate ? "http://localhost:3000" : "https://backend.moco-1.com") + "/admin",
	sentinelBackend: "https://backend.moco-1.com/sentinel"
}